var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToeTouch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06609 16.5625H21.1331L23.0996 19.6882H1.09961L3.06609 16.5625Z",
    stroke: "#43B5F8",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4429 4.55907C17.5152 4.13818 17.4994 3.69526 17.381 3.25582C16.9443 1.63583 15.277 0.676581 13.657 1.11327L9.28996 2.29048C8.45948 2.51435 7.80265 3.06161 7.41851 3.76012C7.24148 4.08204 7.10983 4.39723 7.08075 4.73973C7.07443 5.10738 7.08038 5.32379 7.08052 5.70309V16.656C7.08052 17.5788 7.16523 18.2678 8.08803 18.2678C8.98286 18.2678 9.10637 17.6072 9.26885 16.7381L9.28422 16.656L10.7449 8.18823C10.787 8.17875 10.8292 8.16833 10.8714 8.15697L13.8135 7.36388L13.4382 13.1536C13.4337 13.2079 13.429 13.2612 13.4244 13.3135C13.3647 13.9891 13.3211 14.4839 14.0146 14.5842C14.7619 14.6924 14.9234 14.2804 15.1122 13.5589L17.3563 4.92494C17.392 4.80725 17.4209 4.6869 17.4429 4.55907Z",
    stroke: "#43B5F8",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9943 6.95199C22.5992 6.95199 23.9002 5.65096 23.9002 4.04606C23.9002 2.44116 22.5992 1.14013 20.9943 1.14013C19.3894 1.14013 18.0883 2.44116 18.0883 4.04606C18.0883 5.65096 19.3894 6.95199 20.9943 6.95199Z",
    stroke: "#43B5F8",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToeTouch);
export default __webpack_public_path__ + "static/media/icon_toe-touch.89b78280db383878562335dd987ad562.svg";
export { ForwardRef as ReactComponent };